import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';
import {
  deleteAdminV1StoresStoreIdAnalyticsDestinationsId,
  getAdminV1StoresStoreIdAnalyticsDestinations,
  getAdminV1StoresStoreIdAnalyticsEvents,
  getAdminV1StoresStoreIdAnalyticsSummary,
  patchAdminV1StoresStoreIdAnalyticsDestinationsId,
  postAdminV1StoresStoreIdAnalyticsDestinations,
  postAdminV1StoresStoreIdAnalyticsDestinationsIdTest,
  type AnalyticsDestination,
  type AnalyticsDestinationTestResult,
  type AnalyticsSummary,
  type CreateAnalyticsDestinationRequest,
  type GetAdminV1StoresStoreIdAnalyticsEvents200,
  type GetAdminV1StoresStoreIdAnalyticsSummaryParams,
  type PatchAdminV1StoresStoreIdAnalyticsDestinationsIdBody,
} from '@nucleus-commerce/api-client/admin';

/**
 * Event log params as `toEventParams` builds them: `name=a,b`, `sessionId`, `orderId`, `from`,
 * `to` (UTC days), `cursor`, `limit`.
 */
export type EventListParams = ListParams;

/**
 * Server-side analytics of one store: the destinations events are forwarded to (credentials go
 * in, never come out) and the collected event log. Days are UTC calendar days.
 */
export const analyticsApi = {
  destinations: (storeId: string): Promise<AnalyticsDestination[]> =>
    getAdminV1StoresStoreIdAnalyticsDestinations({ storeId }).then((r) => r.items),
  create: (
    storeId: string,
    body: CreateAnalyticsDestinationRequest,
  ): Promise<AnalyticsDestination> =>
    postAdminV1StoresStoreIdAnalyticsDestinations({ storeId }, body),
  update: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdAnalyticsDestinationsIdBody,
  ): Promise<AnalyticsDestination> =>
    patchAdminV1StoresStoreIdAnalyticsDestinationsId({ storeId, id }, body),
  remove: (storeId: string, id: string): Promise<void> =>
    deleteAdminV1StoresStoreIdAnalyticsDestinationsId({ storeId, id }),
  test: (storeId: string, id: string): Promise<AnalyticsDestinationTestResult> =>
    postAdminV1StoresStoreIdAnalyticsDestinationsIdTest({ storeId, id }),
  summary: (
    storeId: string,
    params: GetAdminV1StoresStoreIdAnalyticsSummaryParams,
  ): Promise<AnalyticsSummary> => getAdminV1StoresStoreIdAnalyticsSummary({ storeId }, params),
  events: (
    storeId: string,
    params: EventListParams,
  ): Promise<GetAdminV1StoresStoreIdAnalyticsEvents200> =>
    getAdminV1StoresStoreIdAnalyticsEvents({ storeId }, params),
};
